import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import DialogsTab from '../components/messenger/DialogsTab';
import CandidatesTab from '../components/messenger/CandidatesTab';
import { useBrandingColors } from '../hooks/useBrandingColors';

type MessengerInnerTab = 'dialogs' | 'candidates';

const MessengerPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const requestedDialogId = searchParams.get('dialogId');
  const colors = useBrandingColors();
  const [activeTab, setActiveTab] = useState<MessengerInnerTab>(() => (
    searchParams.get('tab') === 'candidates' ? 'candidates' : 'dialogs'
  ));

  // Shared campaign selection with localStorage persistence
  // По умолчанию null = "Все вакансии"
  const [selectedCampaign, setSelectedCampaign] = useState<string | null>(() => {
    const saved = localStorage.getItem('aiRecruiter_selectedCampaign');
    console.log('MessengerPage: Loading from localStorage:', saved);
    return saved || null; // null = "Все вакансии"
  });

  // Save to localStorage whenever selectedCampaign changes
  useEffect(() => {
    console.log('MessengerPage: selectedCampaign changed to:', selectedCampaign);
    if (selectedCampaign) {
      localStorage.setItem('aiRecruiter_selectedCampaign', selectedCampaign);
      console.log('MessengerPage: Saved to localStorage:', selectedCampaign);
    } else {
      localStorage.removeItem('aiRecruiter_selectedCampaign');
      console.log('MessengerPage: Removed from localStorage');
    }
  }, [selectedCampaign]);

  useEffect(() => {
    setActiveTab(searchParams.get('tab') === 'candidates' ? 'candidates' : 'dialogs');
  }, [searchParams]);

  const renderTabButton = (tab: MessengerInnerTab, label: string) => {
    const active = activeTab === tab;
    return (
      <button
        type="button"
        onClick={() => setActiveTab(tab)}
        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
          active ? 'bg-white shadow-sm' : 'text-gray-600 hover:text-gray-900 hover:bg-white/60'
        }`}
        style={active ? { color: colors.primary } : undefined}
      >
        {label}
      </button>
    );
  };

  return (
    <div className="bg-[#e9eae2] h-full">
      <div className="w-full h-full flex flex-col gap-6">
        {/* Main Content */}
        <div className="bg-[#f5f6f1] box-border content-stretch flex flex-col gap-[10px] items-start justify-start relative shrink-0 w-full flex-1 h-full overflow-hidden">
          <div className="w-full h-full overflow-y-auto flex flex-col">
            {/* Content without tabs */}
            <div className="flex-1 overflow-hidden flex flex-col bg-white">
              <div className="bg-[#f5f6f1] border-b border-gray-200 px-4 py-3 flex-shrink-0">
                <div className="inline-flex gap-1 rounded-xl border border-gray-200 bg-[#eef0e8] p-1">
                  {renderTabButton('dialogs', 'Диалоги')}
                  {renderTabButton('candidates', 'Список кандидатов')}
                </div>
              </div>
              <div className="flex-1 min-h-0 overflow-hidden">
                {activeTab === 'dialogs' ? (
                  <DialogsTab
                    selectedCampaign={selectedCampaign}
                    setSelectedCampaign={setSelectedCampaign}
                    requestedDialogId={requestedDialogId}
                  />
                ) : (
                  <CandidatesTab
                    selectedCampaign={selectedCampaign}
                    setSelectedCampaign={setSelectedCampaign}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessengerPage;
